// Actions
export const CLEAR_FEEDBACK = 'COMMUNICATION/FEEDBACK/CLEAR_FEEDBACK';
export const SELECT_TOPIC = 'COMMUNICATION/FEEDBACK/SELECT_TOPIC';
export const SEND_EMAIL = 'COMMUNICATION/FEEDBACK/SEND_EMAIL';
export const SET_BODY = 'COMMUNICATION/FEEDBACK/SET_BODY';
export const TOGGLE_MODAL = 'COMMUNICATION/FEEDBACK/TOGGLE_MODAL';
export const TOGGLE_TOPIC_DROPDOWN =
  'COMMUNICATION/FEEDBACK/TOGGLE_TOPIC_DROPDOWN';

/*** Action Creators ***/
export const toggleModal = () => ({
  type: TOGGLE_MODAL
});

export const toggleTopicDropdown = () => ({
  type: TOGGLE_TOPIC_DROPDOWN
});

export const setBody = (body) => ({
  type: SET_BODY,
  body
});

export const clearFeedback = () => ({
  type: CLEAR_FEEDBACK
});

export const selectTopic = (topic) => ({
  type: SELECT_TOPIC,
  topic
});

export const sendEmail = () => ({
  type: SEND_EMAIL
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  modalOpen: false,
  topic: 'Select',
  topicDropdownOpen: false,
  body: ''
};

export default function DatepickerReducer(
  state = DEFAULT_STATE,
  { type, topic, body } = {}
) {
  switch (type) {
    case TOGGLE_MODAL:
      return {
        ...state,
        modalOpen: !state.modalOpen
      };
    case TOGGLE_TOPIC_DROPDOWN:
      return {
        ...state,
        topicDropdownOpen: !state.topicDropdownOpen
      };
    case SET_BODY:
      return {
        ...state,
        body
      };
    case CLEAR_FEEDBACK:
      return DEFAULT_STATE;
    case SELECT_TOPIC:
      return {
        ...state,
        topic
      };
    case SEND_EMAIL:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/communication/feedback/feedbackActions.js